import Icon from '../components/Icon.vue'

Icon.register({"vial":{"width":480,"height":512,"paths":[{"d":"M477.7 186.1L309.5 18.3C306.4 15.2 301.3 15.2 298.2 18.3L264.2 52.2C261.1 55.3 261.1 60.4 264.2 63.5L275.4 74.6 33 316.5C-5.8 355.2-12.1 418.5 23.6 460 44.2 484 73.1 496 102 495.9 128.4 495.9 154.8 485.9 174.9 465.8L421.2 220.1 432.4 231.2C435.5 234.3 440.6 234.3 443.7 231.2L477.7 197.3C480.8 194.3 480.8 189.2 477.7 186.1zM318 256H161L309 108.3 387.5 186.6 318 256z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/vial.js
// module id = null
// module chunks = 